
const state = {
  id: null,
  enabled_portal_option_values: [],
  outgoing_agent_id: null,
}

export const requiredFields = []

export default state
